(function () {

  var tdThemeStrings = (window.theme && theme.strings) ? theme.strings : {};
  function tdString(key, fallback){
    return (typeof tdThemeStrings[key] === 'string' && tdThemeStrings[key]) ? tdThemeStrings[key] : fallback;
  }

  /* ===================================== */
  /* TD Variant Scroll Hint (match product tile v32) */
  /* ===================================== */
  function tdEnsureVariantHintStyle(){
    if (window.__tdVariantHintStyleInjected) return;
    window.__tdVariantHintStyleInjected = true;
    try{
      var st = document.createElement('style');
      st.setAttribute('data-td-variants-scrollhint-style','1');
      st.textContent = '' +
        '.td-tile-variants[data-td-hint-host]{position:relative;}' +
        '.td-variants-scrollhint{position:absolute;left:0;bottom:calc(100% + 8px);background:#000;color:#fff;padding:7px 12px;border-radius:20px;font-size:12px;opacity:0;pointer-events:none;transform:translateY(10px);transition:opacity .25s ease, transform .25s ease;white-space:nowrap;z-index:3;display:inline-flex;align-items:center;gap:6px;}' +
        '.td-variants-scrollhint.is-show{opacity:.9;transform:translateY(0);}' +
        '.td-variants-scrollhint .td-urg-hint__icons{display:inline-flex;align-items:center;gap:2px;}' +
        '.td-variants-scrollhint .td-urg-hint__icon{width:14px;height:14px;display:inline-block;}';
      document.head.appendChild(st);
    } catch(e){}
  }

  function tdVariantHintHtml(){
    return '' +
      '<span class="td-urg-hint__text">' + tdString('tdScrollOrTap', 'Scroll or Tap') + '</span>' +
      '<span class="td-urg-hint__icons">' +
        '<svg class="td-urg-hint__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M15.5 5.5L9 12l6.5 6.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '<svg class="td-urg-hint__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M8.5 5.5L15 12l-6.5 6.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</span>' +
      '<span class="td-urg-hint__text">' + tdString('tdToMove', 'to move') + '</span>';
  }

  function tdWrapEligibleForHint(wrap){
    if (!wrap) return false;
    var track = wrap.querySelector('[data-td-variants-track]');
    var prev = wrap.querySelector('[data-td-variants-prev]');
    var next = wrap.querySelector('[data-td-variants-next]');
    if (!track || !prev || !next) return false;
    if ((track.scrollWidth - track.clientWidth) <= 1) return false;
    var rect = wrap.getBoundingClientRect();
    if (rect.width < 20 || rect.height < 20) return false;
    if (rect.bottom < 0 || rect.top > (window.innerHeight || document.documentElement.clientHeight)) return false;
    return true;
  }

  function tdShowVariantScrollHint(wrap, force){
    if (!wrap || wrap.__tdHintShown) return;
    var now = Date.now();
    if (!force && window.__tdVariantScrollHintLastAt && (now - window.__tdVariantScrollHintLastAt) < 20000) return;
    if (!tdWrapEligibleForHint(wrap)) return;
    if (!force && Math.random() >= 0.65) return;

    var tdNoticeToken = null;
    if (window.TDNoticeQueue) {
      var priority = window.TDNoticeQueue.priority ? window.TDNoticeQueue.priority.variantHint : 25;
      tdNoticeToken = window.TDNoticeQueue.acquire('variant-hint', {
        priority: priority,
        kind: 'info',
        preempt: false,
        preemptible: true,
        onPreempt: function(){
          tdNoticeToken = null;
          var existing = wrap.querySelector('.td-variants-scrollhint');
          if (existing) existing.classList.remove('is-show');
        }
      });
      if (!tdNoticeToken) return;
    }

    tdEnsureVariantHintStyle();
    wrap.setAttribute('data-td-hint-host', '1');

    var hint = wrap.querySelector('.td-variants-scrollhint');
    if (!hint){
      hint = document.createElement('div');
      hint.className = 'td-variants-scrollhint';
      hint.innerHTML = tdVariantHintHtml();
      wrap.appendChild(hint);
    }

    wrap.__tdHintShown = true;
    window.__tdVariantScrollHintLastAt = Date.now();

    requestAnimationFrame(function(){
      if (window.TDNoticeQueue && !tdNoticeToken) return;
      hint.classList.add('is-show');
      setTimeout(function(){
        hint.classList.remove('is-show');
        if (tdNoticeToken && window.TDNoticeQueue) {
          window.TDNoticeQueue.release('variant-hint', tdNoticeToken, 'auto');
          tdNoticeToken = null;
        }
      }, 3000);
    });
  }
  function getCardLink(card) {
    return (
      card.querySelector('a.grid-product__link[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]')
    );
  }

  function getHandleFromLink(a) {
    if (!a) return null;
    var href = a.getAttribute("href") || "";
    var m = href.match(/\/products\/([^\/\?\#]+)/);
    return m && m[1] ? m[1] : null;
  }

  function getCardImg(card) {
    return (
      card.querySelector(".grid-product__image-mask img") ||
      card.querySelector(".grid-product__image img") ||
      card.querySelector("img")
    );
  }

  function tdRvIsSold(dot) {
    return !!(dot && (dot.getAttribute("data-soldout") === "1" || dot.classList.contains("is-soldout")));
  }

  function tdRvFormatMoney(cents){
    cents = parseInt(cents, 10);
    if (isNaN(cents)) return '';
    try{
      if(window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function'){
        return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
      }
    }catch(e){}
    return (cents / 100).toFixed(2);
  }

  function tdRvBuildSavingsText(wrap, priceCents, compareCents){
    if(!wrap || !(compareCents > priceCents)) return '';
    var template = wrap.getAttribute('data-td-save-template') || 'Save __AMOUNT__';
    var saveType = wrap.getAttribute('data-td-save-type') || (window.theme && theme.settings && theme.settings.saveType) || 'dollar';
    var amount = '';
    if(saveType === 'percent'){
      amount = Math.round(((compareCents - priceCents) * 100) / compareCents) + '%';
    } else {
      amount = tdRvFormatMoney(compareCents - priceCents);
    }
    return template.replace('__AMOUNT__', amount);
  }

  function tdRvUpdatePrice(card, dot){
    if(!card || !dot) return;
    var wrap = card.querySelector('[data-td-price-wrap]');
    if(!wrap) return;

    var priceCents = parseInt(dot.getAttribute('data-price-cents') || '', 10);
    if(isNaN(priceCents)) return;
    var compareCents = parseInt(dot.getAttribute('data-compare-cents') || '0', 10) || 0;
    var onSale = compareCents > priceCents;

    var currentNode = wrap.querySelector('[data-td-price-current]');
    var originalNode = wrap.querySelector('[data-td-price-original]');
    var savingsNode = wrap.querySelector('[data-td-price-savings]');
    var regularA11y = wrap.querySelector('[data-td-price-a11y-regular]');
    var saleA11y = wrap.querySelector('[data-td-price-a11y-sale]');

    if(currentNode){
      currentNode.textContent = tdRvFormatMoney(priceCents);
    }

    if(originalNode){
      if(onSale){
        originalNode.textContent = tdRvFormatMoney(compareCents);
        originalNode.style.display = '';
      } else {
        originalNode.textContent = '';
        originalNode.style.display = 'none';
      }
    }

    if(regularA11y) regularA11y.style.display = onSale ? '' : 'none';
    if(saleA11y) saleA11y.style.display = onSale ? '' : 'none';

    if(savingsNode){
      var saveEnabled = wrap.getAttribute('data-td-save-enabled') === '1';
      if(saveEnabled && onSale){
        savingsNode.textContent = tdRvBuildSavingsText(wrap, priceCents, compareCents);
        savingsNode.style.display = '';
      } else {
        savingsNode.textContent = '';
        savingsNode.style.display = 'none';
      }
    }
  }

  function tdRvSetCardState(card, dot) {
    if (!card || !dot) return;

    var soldout = tdRvIsSold(dot);
    var def = card.querySelector("[data-td-tag-default]");
    var so = card.querySelector("[data-td-tag-soldout]");
    if (def && so) {
      def.style.display = soldout ? "none" : "";
      so.style.display = soldout ? "" : "none";
    }

    var qa = card.querySelector("[data-td-quickadd]");
    if (qa) {
      if (soldout) {
        qa.setAttribute("disabled", "disabled");
        qa.classList.add("is-disabled");
      } else {
        qa.removeAttribute("disabled");
        qa.classList.remove("is-disabled");
      }
    }

    var vid = dot.getAttribute("data-variant-id") || "";
    if (!card.hasAttribute('data-td-prompt-selected') && vid) card.setAttribute("data-td-selected-variant-id", vid);

    var a = getCardLink(card);
    var href = dot.getAttribute("data-href");
    if (a && href) a.setAttribute("href", href);
  }

  function tdRvApplySelection(card) {
    if (!card) return;

    var dots = card.querySelectorAll('[data-td-variantdot]');
    if (!dots || !dots.length) return;

    var active = card.querySelector('[data-td-variantdot].is-active');
    var pick = null;

    if (card.hasAttribute('data-td-prompt-selected')) {
      pick = active || dots[0];
    } else if (card.hasAttribute('data-td-user-selected')) {
      pick = active || dots[0];
    } else {
      pick = (active && !tdRvIsSold(active)) ? active : null;
      if (!pick) {
        for (var i = 0; i < dots.length; i++) {
          if (!tdRvIsSold(dots[i])) {
            pick = dots[i];
            break;
          }
        }
      }
      if (!pick) pick = dots[0];
    }

    if (!pick) return;

    for (var j = 0; j < dots.length; j++) dots[j].classList.remove('is-active');
    pick.classList.add('is-active');
    tdRvSetCardState(card, pick);
    tdRvUpdatePrice(card, pick);
  }

  function tdLocalizedPath(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || (window.theme && theme.routes && theme.routes.home) || '/';
    root = String(root || '/');
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(path || '').replace(/^\/+/, '');
  }

  function injectForSection(container) {
    var sectionId = container.getAttribute("data-section-id");
    var output = document.getElementById("RecentlyViewed-" + sectionId);
    if (!output) return;
    if (container.__tdRvUiInit) return;
    container.__tdRvUiInit = true;

    var observer = null;
    var timer = null;
    function injectReadyCards() {
      var cards = output.querySelectorAll(".grid__item.grid-product, .grid-product");
      if (!cards || !cards.length) return false;
      if (timer) clearInterval(timer);
      if (observer) observer.disconnect();

      Array.prototype.forEach.call(cards, function (card) {
        if (!card || card.getAttribute("data-td-injected") === "1") return;

        var a = getCardLink(card);
        var handle = getHandleFromLink(a);
        if (!handle) return;

        var content = card.querySelector(".grid-product__content") || card;
        var meta =
          card.querySelector(".grid-product__meta") ||
          card.querySelector(".grid-product__content") ||
          card;

        fetch(tdLocalizedPath("products/" + handle + "?view=recently-ui"), { credentials: "same-origin" })
          .then(function (r) {
            return r.text();
          })
          .then(function (html) {
            if (!html) return;

            var temp = document.createElement("div");
            temp.innerHTML = html;

            var pack = temp.querySelector("[data-td-rv-ui-pack]");
            if (!pack) return;

            // 1) Overlay (td-tag-slot)
            if (!card.querySelector("[data-td-tag-slot]")) {
              var tagSlot = pack.querySelector("[data-td-tag-slot]");
              if (tagSlot) {
                content.insertAdjacentElement("afterbegin", tagSlot.cloneNode(true));
              }
            }

            // 2) Price (replace existing price block)
            var newPrice = pack.querySelector("[data-td-rv-price]") || pack.querySelector(".grid-product__price");
            var oldPrice = card.querySelector(".grid-product__price");
            if (newPrice && oldPrice) {
              oldPrice.replaceWith(newPrice.cloneNode(true));
            }

            // 3) Variants (append under meta)
            if (!card.querySelector("[data-td-tile-variants]")) {
              var variants = pack.querySelector("[data-td-tile-variants]");
              if (variants) {
                meta.appendChild(variants.cloneNode(true));
              }
            }

            // NEW: update nav enabled/disabled
            tdRvUpdateVariantNav(card);

            // keep nav state updated while user scrolls dots
            var track = card.querySelector('[data-td-tile-variants] [data-td-variants-track]');
            if (track && !track.__tdRvNavBound) {
              track.__tdRvNavBound = true;
              track.addEventListener('scroll', function(){ tdRvUpdateVariantNav(card); }, { passive: true });
              window.addEventListener('resize', function(){ tdRvUpdateVariantNav(card); }, { passive: true });
            }

            // 4) Initialize selected variant id for quick-add
            var selVid = pack.getAttribute("data-td-selected-variant-id") || "";
            if (selVid) card.setAttribute("data-td-selected-variant-id", selVid);

            // Ensure soldout tag state for product-level availability before exact variant sync
            var prodAvail = pack.getAttribute("data-td-product-available") === "1";
            var def = card.querySelector("[data-td-tag-default]");
            var so = card.querySelector("[data-td-tag-soldout]");
            if (def && so) {
              def.style.display = prodAvail ? "" : "none";
              so.style.display = prodAvail ? "none" : "";
            }

            var qaBtn = card.querySelector("[data-td-quickadd]");
            if (qaBtn) {
              if (!prodAvail) {
                qaBtn.setAttribute("disabled", "disabled");
                qaBtn.classList.add("is-disabled");
              } else {
                qaBtn.removeAttribute("disabled");
                qaBtn.classList.remove("is-disabled");
              }
            }

            tdRvApplySelection(card);
            tdRvEnsureWishlistButton(card, handle, prodAvail);

            card.setAttribute("data-td-injected", "1");

            if (window.theme && typeof theme.reinitProductGridItem === "function") {
              theme.reinitProductGridItem(card);
            }
            tdRvApplySelection(card);
          })
          .catch(function () {});
      });
      return true;
    }

    if (injectReadyCards()) return;
    // The native section renders on first view, including after a long scroll.
    if (window.MutationObserver) {
      observer = new MutationObserver(injectReadyCards);
      observer.observe(output, { childList: true, subtree: true });
    } else {
      var tries = 0;
      timer = setInterval(function () {
        if (injectReadyCards() || ++tries > 120) clearInterval(timer);
      }, 200);
    }
  }


  function tdRvWishlistIconMarkup() {
    return '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="element-icon element-icon-heart element-icon--line" viewBox="0 0 64 64" width="20" height="20"><path d="M51.27 15.05a13 13 0 0 0-18.44 0l-.83.83-.83-.83a13 13 0 0 0-18.44 18.44l.83.83L32 52.77l18.44-18.45.83-.83a13 13 0 0 0 0-18.44" fill="none" stroke="currentColor"></path></svg>';
  }

  function tdRvEnsureWishlistButton(card, handle, productAvailable) {
    if (!card || card.querySelector('[data-td-wishlist-toggle]')) return;

    var content = card.querySelector('.grid-product__content') || card;
    var link = getCardLink(card);
    var titleEl = card.querySelector('.grid-product__title');
    var imgEl = card.querySelector('.grid-product__image-mask img') || card.querySelector('.grid-product__image img');
    var label = (window.theme && theme.strings && theme.strings.tdWishlistAdd) ? theme.strings.tdWishlistAdd : 'Add to Wishlist';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'td-wishlist-toggle td-wishlist-tile';
    btn.setAttribute('data-td-wishlist-toggle', '');
    btn.setAttribute('data-td-wishlist-source', 'tile');
    if (handle) btn.setAttribute('data-handle', handle);
    if (card.getAttribute('data-product-id')) btn.setAttribute('data-product-id', card.getAttribute('data-product-id'));
    if (link && link.getAttribute('href')) {
      btn.setAttribute('data-url', link.getAttribute('href'));
      btn.setAttribute('data-product-url', link.getAttribute('href'));
    }
    if (titleEl && titleEl.textContent) btn.setAttribute('data-title', titleEl.textContent.trim());
    if (imgEl && (imgEl.currentSrc || imgEl.src)) btn.setAttribute('data-image', imgEl.currentSrc || imgEl.src);
    btn.setAttribute('data-available', productAvailable ? 'true' : 'false');
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', label);
    btn.innerHTML = tdRvWishlistIconMarkup();

    var slot = card.querySelector('[data-td-tag-slot]') || content;
    slot.appendChild(btn);
  }

  function tdRvScrollTrack(btn, dir){
    var wrap = btn ? btn.closest('[data-td-tile-variants]') : null;
    if (!wrap) return;

    var track = wrap.querySelector('[data-td-variants-track]');
    if (!track) return;

    var dots = track.querySelectorAll('[data-td-variantdot]');
    if (!dots || !dots.length) return;

    var current = track.scrollLeft;
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var target = current;
    var tolerance = 6;

    if (dir > 0) {
      for (var i = 0; i < dots.length; i++) {
        var left = dots[i].offsetLeft;
        if (left > current + tolerance) {
          target = left;
          break;
        }
      }

      if (target === current) target = maxScroll;
    } else {
      for (var j = dots.length - 1; j >= 0; j--) {
        var leftPrev = dots[j].offsetLeft;
        if (leftPrev < current - tolerance) {
          target = leftPrev;
          break;
        }
      }

      if (target === current) target = 0;
    }

    if (target < 0) target = 0;
    if (target > maxScroll) target = maxScroll;

    var hint = wrap.querySelector('.td-variants-scrollhint');
    if (hint) hint.classList.remove('is-show');

    track.scrollTo({
      left: target,
      behavior: 'smooth'
    });
  }

  function tdRvUpdateVariantNav(card){
    if (!card) return;

    var wrap = card.querySelector('[data-td-tile-variants]');
    if (!wrap) return;

    var track = wrap.querySelector('[data-td-variants-track]');
    var prev = wrap.querySelector('[data-td-variants-prev]');
    var next = wrap.querySelector('[data-td-variants-next]');
    if (!track || !prev || !next) return;

    var maxScroll = track.scrollWidth - track.clientWidth;

    if (maxScroll <= 1) {
      prev.classList.add('is-disabled');
      next.classList.add('is-disabled');
      prev.setAttribute('disabled','disabled');
      next.setAttribute('disabled','disabled');
      return;
    }

    prev.classList.remove('is-disabled');
    next.classList.remove('is-disabled');
    prev.removeAttribute('disabled');
    next.removeAttribute('disabled');

    var left = track.scrollLeft;

    if (left <= 1) {
      prev.classList.add('is-disabled');
      prev.setAttribute('disabled','disabled');
    }

    if (left >= maxScroll - 1) {
      next.classList.add('is-disabled');
      next.setAttribute('disabled','disabled');
    }

    tdShowVariantScrollHint(wrap, false);
  }

  // --- Variant dot click: DO NOT navigate; swap image; update href; toggle labels; update selected variant id
  function onDotClick(e) {
    var btn = e.target.closest('[data-td-variantdot]');
    if (!btn) return;

    var rvWrap = btn.closest('[data-section-type="recently-viewed"]');
    if (!rvWrap) return;

    // critical for iOS Safari
    if (e.type === "touchstart") e.preventDefault();
    if (e.cancelable) e.preventDefault();

    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    var card = btn.closest(".grid__item.grid-product, .grid-product");
    if (!card) return;

    // active state
    card.setAttribute('data-td-user-selected', '1');
    var wrap = btn.closest("[data-td-tile-variants]") || card;
    var actives = wrap.querySelectorAll("[data-td-variantdot].is-active");
    for (var i = 0; i < actives.length; i++) actives[i].classList.remove("is-active");
    btn.classList.add("is-active");

    // swap image
    var img = getCardImg(card);
    var nextSrc =
      btn.getAttribute("data-img320") ||
      btn.getAttribute("data-img240") ||
      btn.getAttribute("data-img160");
    if (img && nextSrc) {
      img.setAttribute("src", nextSrc);
      if (img.hasAttribute("srcset")) img.setAttribute("srcset", nextSrc);
      if (img.hasAttribute("data-src")) img.setAttribute("data-src", nextSrc);
      if (img.hasAttribute("data-srcset")) img.setAttribute("data-srcset", nextSrc);
    }

    // update link to selected variant
    var a = getCardLink(card);
    var href = btn.getAttribute("data-href");
    if (a && href) a.setAttribute("href", href);

    // update selected variant id (used by quick add)
    var vid = btn.getAttribute("data-variant-id") || "";
    if (vid) card.setAttribute("data-td-selected-variant-id", vid);
    try { if (window.TDVariantPrompt && typeof window.TDVariantPrompt.clearCardVariantDetails === 'function') { window.TDVariantPrompt.clearCardVariantDetails(card); } } catch (e) {}

    tdRvSetCardState(card, btn);
    tdRvUpdatePrice(card, btn);
    tdRefreshWishlistButtons();
  }

  // --- Quick add (copied behavior from product-grid-item.liquid, executed here because injected scripts won't run)
  function closest(el, sel) {
    while (el && el !== document) {
      if (el.matches && el.matches(sel)) return el;
      el = el.parentNode;
    }
    return null;
  }

  function tdRefreshWishlistButtons() {
    try {
      if (window.TDWishlist && typeof window.TDWishlist.refreshButtons === "function") {
        window.TDWishlist.refreshButtons();
      }
    } catch (e) {}
  }

  function tdTileFlyToCart(startEl, imgSrc) {
    if (!imgSrc) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var cartIcon =
      document.querySelector(".js-drawer-open-cart .cart-link") ||
      document.querySelector(".js-drawer-open-cart");

    if (!cartIcon) return;

    var startRect =
      (startEl || document.documentElement).getBoundingClientRect
        ? (startEl || document.documentElement).getBoundingClientRect()
        : null;
    if (!startRect) return;

    var endRect = cartIcon.getBoundingClientRect();

    var startX = startRect.left + startRect.width / 2;
    var startY = startRect.top + startRect.height / 2;
    var endX = endRect.left + endRect.width / 2;
    var endY = endRect.top + endRect.height / 2;

    var bubble = document.createElement("div");
    bubble.className = "td-fly-to-cart";
    bubble.style.backgroundImage = 'url("' + imgSrc + '")';
    bubble.style.left = startX + "px";
    bubble.style.top = startY + "px";
    document.body.appendChild(bubble);

    requestAnimationFrame(function () {
      bubble.classList.add("td-fly-to-cart--go");
      bubble.style.left = endX + "px";
      bubble.style.top = endY + "px";
    });

    var cleanup = function () {
      if (bubble) bubble.remove();
    };
    bubble.addEventListener("transitionend", cleanup, { once: true });
    setTimeout(cleanup, 1400);
  }

  function tdTileAddToCart(variantId, btn) {
    if (!variantId) return;
    if (btn) btn.classList.add("btn--loading");

    var body = new URLSearchParams();
    body.append("id", variantId);
    body.append("quantity", "1");

    fetch((window.theme && theme.routes && theme.routes.cartAdd) ? theme.routes.cartAdd : "/cart/add.js", {
      method: "POST",
      body: body.toString(),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && data.status === 422) {
          try {
            if (window.TDNoticeQueue) window.TDNoticeQueue.interrupt('browser-dialog', 130);
            alert(data.description || data.message || tdString('soldOut', 'Sold out'));
          } catch (e) {}
        } else {
          try {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: { product: data, addToCartBtn: btn },
                bubbles: true,
              })
            );
          } catch (e) {}
        }
      })
      .catch(function () {})
      .finally(function () {
        if (btn) btn.classList.remove("btn--loading");
      });
  }

  function onQuickAddClick(e) {
    var qa = e.target && e.target.closest
      ? e.target.closest('[data-section-type="recently-viewed"] [data-td-quickadd]')
      : null;
    if (!qa) return;

    if (e.cancelable) e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    if (qa.disabled || qa.classList.contains("is-disabled")) return;

    var card = closest(qa, ".grid__item.grid-product, .grid-product");
    if (!card) return;

    // block when selected dot is sold out
    var activeDot = card.querySelector('[data-td-variantdot].is-active');
    if (activeDot && (activeDot.getAttribute("data-soldout") === "1" || activeDot.classList.contains("is-soldout"))) {
      qa.disabled = true;
      qa.classList.add("is-disabled");
      return;
    }

    var imgEl = card.querySelector(".grid-product__image-mask img");
    var imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src) : null;

    if (window.TDVariantPrompt && typeof window.TDVariantPrompt.resolve === 'function') {
      window.TDVariantPrompt.resolve(card, { action: 'cart', triggerEl: qa }).then(function(result){
        if (!result || result.status !== 'resolved' || !result.variantId) return;
        tdTileFlyToCart(imgEl || qa, imgSrc);
        tdTileAddToCart(result.variantId, qa);
      });
      return;
    }

    var vid = card.getAttribute("data-td-selected-variant-id") || "";
    if (!vid) return;

    tdTileFlyToCart(imgEl || qa, imgSrc);
    tdTileAddToCart(vid, qa);
  }

  // MUST include touchstart with passive:false (ONLY ONCE)
  document.addEventListener("touchstart", onDotClick, { capture: true, passive: false });
  document.addEventListener("pointerdown", onDotClick, true);
  document.addEventListener("click", onDotClick, true);

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-section-type="recently-viewed"] [data-td-variants-prev], [data-section-type="recently-viewed"] [data-td-variants-next]');
    if (!btn) return;

    if (btn.disabled || btn.classList.contains('is-disabled')) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    var dir = btn.hasAttribute('data-td-variants-next') ? 1 : -1;
    tdRvScrollTrack(btn, dir);

    var card = btn.closest(".grid__item.grid-product, .grid-product");
    tdRvUpdateVariantNav(card);
  }, true);

  document.addEventListener("click", onQuickAddClick, true);

  function initRecentlyViewedUi() {
    document.querySelectorAll('[data-section-type="recently-viewed"]').forEach(injectForSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", initRecentlyViewedUi, { once: true });
  } else {
    initRecentlyViewedUi();
  }
})();
